"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAIN = exports.GALLERY_BUTTON = void 0;
const MAIN = exports.MAIN = 'main';
const GALLERY_BUTTON = exports.GALLERY_BUTTON = 'gallery-button';
